import Box from "@cloudscape-design/components/box"
import { getAppVersion } from "../../appVersion"

const footerStyle = {
  backgroundColor: "var(--color-header-bg)",
  color: "rgba(255, 255, 255, 0.6)",
  position: "relative" as const,
}

// Pin the version to the right edge, vertically centered, without affecting the
// centered copyright line (absolute so it is out of normal flow).
const versionStyle = {
  position: "absolute" as const,
  right: 0,
  top: 0,
  bottom: 0,
  display: "flex",
  alignItems: "center",
  paddingRight: "1rem",
}

const Footer = () => {
  return (
    <footer id="app-footer" style={footerStyle}>
      <Box textAlign="center" padding="m" color="inherit">
        <Box variant="span" fontSize="body-s" color="inherit">
          &copy; {new Date().getFullYear()} Amazon Web Services Professional Services. All rights
          reserved.
        </Box>
      </Box>
      <div style={versionStyle}>
        <Box variant="span" fontSize="body-s" color="inherit">
          {getAppVersion()}
        </Box>
      </div>
    </footer>
  )
}

export default Footer
